<div class="d-flex align-items-center mb-5 justify-content-between" >
    <div role="button" class="d-flex align-items-center justify-content-center"  (click)="back()">
        <img src="/img/back-arrow.svg" alt="">
        <span class="back-button">Volver</span>
    </div>
    <img src="img/logo.svg" class="capital-logo d-flex-item d-lg-none">
</div> 